import { useState } from "react";
import { FaPlus } from "react-icons/fa6";
import { useTranslation } from "react-i18next";
import { css } from "../../../../../styled-system/css";
import { MenuButton, Menu, MenuItem } from "../../../../components/core/basic/Menu";
import { SearchInput } from "../../../../components/fields/base/TextField";

export function FilterColumnSelector({
  filterOptions,
  onSelect,
}: {
  filterOptions: { id: string; label: string }[];
  onSelect: (id: string) => void;
}) {
  const { t } = useTranslation(["merchandising"]);
  const [search, setSearch] = useState("");
  return (
    <MenuButton
      buttonProps={{
        variant: "contentOnly",
      }}
      label={
        <span className="fs-5 text-muted">
          <FaPlus /> {t(($) => $.merchandising["Add filter"])}
        </span>
      }
    >
      <SearchInput
        aria-label={t(($) => $.merchandising["Filter by"])}
        placeholder={t(($) => $.merchandising["Filter By..."])}
        css={{
          margin: "small",
        }}
        value={search}
        onChange={setSearch}
      />
      <Menu onClose={() => setSearch("")} className={css({ maxHeight: "33vh", overflowY: "auto" })}>
        {filterOptions
          .filter((filterable) => filterable.label.toLowerCase().includes(search.toLowerCase()))
          .map((filterable) => (
            <MenuItem key={filterable.id} onAction={() => onSelect(filterable.id)}>
              {filterable.label}
            </MenuItem>
          ))}
      </Menu>
    </MenuButton>
  );
}
